const Statistices = () => {
 return (
    <>


<div className="col-xl-3 col-sm-6" >
<div className="card">
    <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
            <div className={`icon-box icon-box-lg rounded-circle bg-success-light`} >
            <i class="fa-solid fa-pepper-hot"width="46" height="46"></i>  
            </div>
            <div class="total-projects ms-3">
    <h3 class="count text-success">123k</h3>
<span>Total In Cancel</span>
</div>
          
        </div>
    </div>
</div>
</div>
<div className="col-xl-3 col-sm-6" >
<div className="card">
    <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
            <div className={`icon-box icon-box-lg rounded-circle bg-success-light`} >
            <i class="fa-solid fa-pepper-hot"width="46" height="46"></i>  
            </div>
            <div class="total-projects ms-3">
    <h3 class="count text-success">123k</h3>
<span>Total In Cancel</span>
</div>
            
        </div>
    </div>
</div>
</div>

<div className="col-xl-3 col-sm-6" >
<div className="card">
    <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
            <div className={`icon-box icon-box-lg rounded-circle bg-success-light`} >
            <i class="fa-solid fa-pepper-hot"width="46" height="46"></i>  
            </div>
            <div class="total-projects ms-3">
    <h3 class="count text-success">123k</h3>
<span>Total In Cancel</span>
</div>
           
        </div>
    </div>
</div>
</div>
<div className="col-xl-3 col-sm-6">
<div className="card">
    <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
            <div className={`icon-box icon-box-lg rounded-circle bg-success-light`} >
            <i class="fa-solid fa-pepper-hot"width="46" height="46"></i>  
            </div>
            <div class="total-projects ms-3">
    <h3 class="count text-success">123k</h3>
<span>Total In Cancel</span>
</div>


        
        </div>
    </div>
</div>
</div>
</>
);
 }
 export default Statistices;